import { useState } from 'react';
import { Dropdown, Button, Modal } from 'react-bootstrap';
import axios from "axios";

function Sposta_alunno_nel_cestino(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const cancellazione_alunno = (parametro) => {
//    console.log(input);
    //        axios.post('http://localhost:3001/create', newNote)
    console.log('ENTRATO')

    console.log(props)
    axios.patch('/alunni/cancella_alunno/' + props.alunno._id + '/' + parametro)
        .then((res) => {
            console.log(res.data)

        }).catch((error) => {
            console.log(error)
        });
    props.SET_variab_aggiorna(current => !current)
    setShow(false)

  }

  return (
    <>
 
      {props.alunno.cestino == 0 && <Dropdown.Item 
                                     onClick={() => setShow(true)}>Cancella Alunno</Dropdown.Item>}
      {props.alunno.cestino == 1 && <Dropdown.Item 
                                      onClick={() => cancellazione_alunno (0)}>Ripristina Alunno</Dropdown.Item> }
                                       


      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Sposta l'alunno nel cestino</Modal.Title>
        </Modal.Header>
        <Modal.Body>Per recuperare l'alunno dovrai contattare gli amministratori dell'applicazione</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Annulla
          </Button>
          <Button variant="primary" onClick={() => cancellazione_alunno(1)}>
            Cancella
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Sposta_alunno_nel_cestino;